document.addEventListener("DOMContentLoaded", function () {

  function initFormLabels() {
    const formFields = document.querySelectorAll('.themeForm .hs-form-field:not(.hs-fieldtype-checkbox):not(.hs-fieldtype-radio):not(.hs-fieldtype-phonenumber):not(.hs-fieldtype-booleancheckbox)');

    formFields.forEach(field => {
      const input = field.querySelector('input, textarea, select');

      if (!input) return;

      // Check if input has value on page load
      function checkValue() {
        if (input.value && input.value.trim() !== '') {
          field.classList.add('has-value');
        } else {
          field.classList.remove('has-value');
        }
      }

      // Hide disabled option in select elements
      if (input.tagName === 'SELECT') {
        const disabledOption = input.querySelector('option[disabled]');
        if (disabledOption) {
          disabledOption.textContent = '';
        }
      }

      // Initial check
      checkValue();

      // Listen for input changes
      input.addEventListener('input', checkValue);
      input.addEventListener('change', checkValue);
      input.addEventListener('blur', checkValue);

      // Handle autofill detection
      input.addEventListener('animationstart', function (e) {
        if (e.animationName === 'onAutoFillStart') {
          setTimeout(checkValue, 100);
        }
      });
    });
  }

  // Initialize immediately
  initFormLabels();

  // Re-initialize when HubSpot forms are loaded (they load asynchronously)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && (node.classList.contains('hs-form') || node.querySelector('.hs-form'))) {
          setTimeout(initFormLabels, 100); // Small delay to ensure form is fully rendered
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});
